export const EXTERNAL_SITE_ROUTES = {
  HQ_PLUS_PRICING_SECTION: '/hq/plus#pricing',
};
